import { render, staticRenderFns } from "./GerenciamentoRelogiosTarefas.vue?vue&type=template&id=5cdeee7c&"
import script from "./GerenciamentoRelogiosTarefas.vue?vue&type=script&lang=js&"
export * from "./GerenciamentoRelogiosTarefas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports